'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'screen-users';
var width = 640;
var height = 512;
var aliases = ["users-class"];
var unicode = 'f63d';
var svgPathData = 'M116 416h-40C34.13 416 0 451.9 0 496C0 504.8 7.25 512 16 512S32 504.8 32 496C32 469.5 51.75 448 76 448h40C140.3 448 160 469.5 160 496C160 504.8 167.3 512 176 512S192 504.8 192 496C192 451.9 157.9 416 116 416zM564 416h-40C482.1 416 448 451.9 448 496c0 8.75 7.25 16 16 16s16-7.25 16-16c0-26.5 19.75-48 44-48h40C588.3 448 608 469.5 608 496c0 8.75 7.25 16 16 16s16-7.25 16-16C640 451.9 605.9 416 564 416zM340 416h-40C258.1 416 224 451.9 224 496C224 504.8 231.3 512 240 512S256 504.8 256 496C256 469.5 275.8 448 300 448h40C364.3 448 384 469.5 384 496c0 8.75 7.25 16 16 16s16-7.25 16-16C416 451.9 381.9 416 340 416zM256.2 320c0 35.35 28.44 63.98 63.79 63.98S383.8 355.3 383.8 320S355.3 256 320 256S256.2 284.7 256.2 320zM352 320c0 17.64-14.36 32-32 32s-32-14.36-32-32s14.36-32 32-32S352 302.4 352 320zM544 256c-35.35 0-63.79 28.64-63.79 63.98S508.7 383.1 544 383.1S607.8 355.3 607.8 320S579.3 256 544 256zM544 352c-17.64 0-32-14.36-32-32s14.36-32 32-32s32 14.36 32 32S561.6 352 544 352zM96 383.1c35.35 0 63.79-28.64 63.79-63.98S131.3 256 96 256S32.21 284.7 32.21 320S60.65 383.1 96 383.1zM96 288c17.64 0 32 14.36 32 32s-14.36 32-32 32s-32-14.36-32-32S78.36 288 96 288zM48 240C56.84 240 64 232.8 64 224V48C64 39.17 71.19 32 80 32h480C568.8 32 576 39.17 576 48V224c0 8.844 7.156 16 16 16S608 232.8 608 224V48c0-26.47-21.53-47.1-48-47.1h-480C53.53 .0001 32 21.53 32 48V224C32 232.8 39.16 240 48 240z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faScreenUsers = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;